module.exports = __webpack_public_path__ + "img/shift-fill.4c5d25bf.svg";